import { composeIO } from 'react-compose-io'
import { regraNotaFiscalFormIO } from './RegraNotaFiscalForm.IO'
import RegraNotaFiscalFormView from './RegraNotaFiscalForm.View'

export const RegraNotaFiscalForm = composeIO(RegraNotaFiscalFormView, regraNotaFiscalFormIO)
